import { inject, Pipe, type PipeTransform } from '@angular/core';

import { PRIMITIVE_MULTI_TABLE_WORDINGS } from '../../primitive-multi-table.wordings';

@Pipe({
  name: 'totalElementsTranslate',
})
export class TotalElementsTranslatePipe implements PipeTransform {
  private readonly _wordings = inject(PRIMITIVE_MULTI_TABLE_WORDINGS);

  public transform(elements: number): string {
    const formList = this._wordings._library.message.formList;

    switch (elements) {
      case 0: {
        return formList.totalNoElements();
      }
      case 1: {
        return formList.totalOneElement();
      }
      default: {
        return formList.totalSeveralElements({
          bindings: { number: elements },
        });
      }
    }
  }
}
